
import React from "react";
import { motion } from "framer-motion";

interface LoginLeftPanelProps {
  loaded: boolean;
}

const LoginLeftPanel = ({ loaded }: LoginLeftPanelProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: loaded ? 1 : 0, x: loaded ? 0 : -50 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="hidden md:flex md:w-1/2 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-black opacity-95" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-transparent" />
      
      <div className="relative z-10 flex flex-col justify-center px-12 py-8 max-w-xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: loaded ? 1 : 0, y: loaded ? 0 : 20 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white leading-tight">
            Embark on <span className="text-anzir">MysteryAct</span> Adventures
          </h2>
          
          <p className="text-gray-300 text-lg mb-8">
            Join our global community of mystery solvers, story creators, and venue hosts. 
            Experience the thrill of immersive mysteries and adventures.
          </p>
          
          <div className="space-y-6">
            <div className="flex items-start">
              <div>
                <h3 className="text-white font-medium text-lg">Create & Explore</h3>
                <p className="text-gray-400">Craft compelling stories or dive into mysteries created by others</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div>
                <h3 className="text-white font-medium text-lg">Play Anywhere</h3>
                <p className="text-gray-400">Experience mysteries online or at physical locations worldwide</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div>
                <h3 className="text-white font-medium text-lg">Community & Connection</h3>
                <p className="text-gray-400">Connect with like-minded enthusiasts and expand your network</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LoginLeftPanel;
